// removed by extract-text-webpack-plugin
module.exports = {"display1":"_2CmE9EC4NSNo9TYMvVdVSE","display2":"_1Jzhx3c8-ENje8qQNXyLWA","display3":"_1Qo0YKkDubM5BbARHAALda","bold":"_2p1tTwhScvL6CZqVEnA51k","italic":"_2Lk3YWoVibizfQXPp1bUqO"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/atoms/Display/style.css
// module id = 434
// module chunks = 39